<template>
	<page>
		<module title="积分规则配置">
            <c-form ref="form">
                <c-form title="基础配置">
                    <c-form-item type="number" label="积分有效期时长" name="ORDER_POINTS_EXPIRED_PERIOD" :limit="[1,9999]" required input-unit="月"  word="积分获取后超过该期限还未使用，则自动失效"></c-form-item>
                </c-form>
                <c-form title="下单送积分">
                    <c-form-item type="radio" label="下单是否赠送积分" name="ORDER_POINTS_ENABLED" :options="enabledType" v-model="order_points_enabled" required
                                 word="赠送积分将在订单确认收货后,根据实际收货的商品金额计算对应积分">
                    </c-form-item>
                    <c-form-item type="number" decimal="2" v-show="order_points_enabled=='ON'" label="下单时获得1积分需消费" name="ORDER_POINTS_MONEY_UNIT" :limit="[0.01,9999]" input-unit="元" required word="获得积分将向下取整,即计算得出应赠送【5.9】分，最终获得积分为【5】分"></c-form-item>
                </c-form>
<!--                <c-form title="积分抵扣规则">
                    <c-form-item type="number" label="抵扣一元人民币需" name="ORDER_MONEY_POINTS_UNIT" :limit="[1,9999]" required input-unit="分"></c-form-item>
                    <c-form-item type="number" label="单笔订单最高可抵扣" name="ORDER_MONEY_PERCENT" :limit="[0,99]"  required input-unit="%" word="仅能用于抵扣商品金额，不可抵扣运费等其他费用；单次抵扣不能少于0.01元"></c-form-item>
                </c-form>-->
            </c-form>
            <template slot="button">
                <c-button size="m" @click="submit">提交保存</c-button>
            </template>
		</module>
        <!--配置签到周期弹窗-->
        <c-dialog ref="signInCalendarEdit" title="签到奖励配置" width="600" @resolve="submitSignInAwardConfig">
              <m-operate>
                  <c-button color="gray" hollow @click="addSignInCalendarRow()">添加行</c-button>
              </m-operate>
                <c-table v-model="signInCalendarData" border height="400">
                    <c-table-column
                        label="签到天数"
                        width="120"
                    >
                      <template v-slot="{data, index}">
                          {{`第${index + 1}天`}}
                      </template>
                    </c-table-column>

                    <c-table-column
                        label="签到奖励积分"
                        width="150"
                    >
                      <template v-slot="row">
                        <c-input v-model="row.data.award_points" type="number" decimal="0"  :limit="[1,100]" word="分" width="100px"></c-input>
                      </template>
                    </c-table-column>

                    <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="70"
                    >
                      <template v-slot="row">
                        <c-table-button @click="row.remove()">删除</c-table-button>
                      </template>
                    </c-table-column>
                </c-table>
            </c-dialog>
        <!--配置浏览页面任务弹窗-->
        <c-dialog ref="browsePageDialogEdit" title="配置浏览送积分【页面】" width="800" @resolve="submitBrowsePageConfig">
              <m-operate>
                  <c-button color="gray" hollow @click="addBrowsePageRow()">添加页面</c-button>
              </m-operate>
                <c-table v-model="browsePageData" border height="400">
                    <c-table-column
                        label="页面类型"
                        width="120"
                    >
                        <template v-slot="row">
                            <c-select v-model="row.data.page_type" width="60" :options="pageTypeOptions"></c-select>
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="页面名称"
                        width="120"
                    >
                        <template v-slot="row">
                                <c-select v-if="row.data.page_type == -1" v-model="row.data.page_id" width="60" :options="systemPageList"></c-select>
                                <c-select v-else-if="row.data.page_type == 5" v-model="row.data.page_id" width="60" :options="decoratePageList"></c-select>
                                <span v-else style="color: red">请选择页面类型</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="浏览时长"
                            width="150"
                    >
                        <template v-slot="row">
                            <c-input v-model="row.data.browse_duration" type="number" decimal="0"  :limit="[1,9999]" word="秒" width="100px"></c-input>
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="奖励积分"
                        width="150"
                    >
                      <template v-slot="row">
                        <c-input v-model="row.data.award_points" type="number" decimal="0"  :limit="[1,9999]" word="分" width="100px"></c-input>
                      </template>
                    </c-table-column>

                    <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="70"
                    >
                      <template v-slot="row">
                        <c-table-button @click="row.remove()">删除</c-table-button>
                      </template>
                    </c-table-column>
                </c-table>
            </c-dialog>
        <!--配置浏览商品任务弹窗-->
        <c-dialog ref="browseProductDialogEdit" title="配置浏览送积分【商品】" width="800" @resolve="submitBrowseProductConfig">
              <m-operate>
                  <c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
              </m-operate>
                <c-table v-model="browseProductList" border height="400">
                    <c-table-column
                            label="商品信息"
                            name="page_name"
                            width="250"
                    >
                        <template v-slot="{data}">
                            <div class="flex-center">
                                <c-image :src="data.product_img_url" size="46" preview></c-image>
                                <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                                    {{data.page_name}}
                                </p>
                            </div>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="浏览时长"
                            width="150"
                    >
                        <template v-slot="row">
                            <c-input v-model="row.data.browse_duration" type="number" decimal="0"  :limit="[1,9999]" word="秒" width="100px"></c-input>
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="奖励积分"
                        width="150"
                    >
                      <template v-slot="row">
                        <c-input v-model="row.data.award_points" type="number" decimal="0"  :limit="[1,9999]" word="分" width="100px"></c-input>
                      </template>
                    </c-table-column>

                    <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="70"
                    >
                      <template v-slot="row">
                        <c-table-button @click="row.remove()">删除</c-table-button>
                      </template>
                    </c-table-column>
                </c-table>
            </c-dialog>

        <coupon-selector ref="couponSelector" @resolve="couponSelectHandle($event)"></coupon-selector>
        <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
   import couponSelector from '@/components/service/coupon_selector.vue'
   import productSelector from "@/components/service/product_selector.vue";
	export default {
		name: 'm_points_regulation',
        data() {
              return {
                enabledType: [{
                  name: '赠送积分',
                  value: 'ON'
                }, {
                  name: '不送积分',
                  value: 'OFF'
                }],
                order_points_enabled:'OFF',
                signInCalendarData:[],
                pageTypeOptions: [
                      {name: '系统页',value: -1},
                      {name: '装修页',value: 5}
                ],
                support_flag:2,//2=移动端
                browsePageData:[],
                systemPageList:[],
                decoratePageList:[],
                browseProductList:[],
                SIGN_IN_CONTINUITY_REWARD_COUPON_ID:0
              }
        },
        components: {
            productSelector,
            couponSelector
        },
        mounted() {
            this.getDetail();
            this.initDecotatePageInfo();
        },

        methods: {
            couponSelectHandle(list, ref, key) {
                var couponInfo = list[0];
                this.$refs.form.set({
                   "SIGN_IN_CONTINUITY_REWARD_COUPON_NAME":couponInfo.coupon_name,
                   "SIGN_IN_CONTINUITY_REWARD_COUPON_ID":couponInfo.id
                });
            },
            //删除已选优惠券
            removeCouponSelect(){
                this.$refs.form.set({
                    "SIGN_IN_CONTINUITY_REWARD_COUPON_NAME":'',
                    "SIGN_IN_CONTINUITY_REWARD_COUPON_ID":0
                });
            },
            productSelectHandle(list) {
                list = list.filter(item => {
                    return !this.browseProductList.find(row => {
                        return row.browseProductList == item.product_id;
                    });
                });
                this.browseProductList = this.browseProductList.concat(list);
                this.browseProductList = this.browseProductList.map(item => {
                    item.page_type = 8;
                    item.page_id = item.product_id;
                    item.browse_duration = 10;
                    item.award_points = 1;
                    item.page_name = (item.product_itemnumber?(item.product_itemnumber+'-'):('')) + item.product_name;
                    return item;
                });
            },
            /**
             * 加载页面已经配置的数据详情
             */
            getDetail(){
              this.request({
                url: '/platform_config/list',
                data: {
                    config_group: ""
                },
                loading: true,
                success: data => {
                  let json = {};
                  data.forEach(function (item,i){
                    if(item.config_item_code=='STATION_WITHDRAWAL_RATE' || item.config_item_code=='WITHDRAWAL_RATE'){
                      json[item.config_item_code] = parseFloat(item.config_item_value) * 100;
                    }else{
                      json[item.config_item_code] = item.config_item_value;
                    }
                  });
                  this.$refs.form.set(json);
                }
              });
            },
            /**
             * 初始化装修数据
             */
            initDecotatePageInfo() {
                this.request({
                    url: '/decoration/common/sys_page',
                    data: {
                        support_flag: this.support_flag
                    },
                    success: data => {
                        this.systemPageList = Array.from(data, item => {
                            return {
                                name: item.name,
                                value: item.id.toString()
                            }
                        });
                    }
                });
                this.request({
                    url: '/decoration/template/effective',
                    data: {
                        support_flag:this.support_flag
                    },
                    success: template => {
                        this.request({
                            url: '/decoration/common/page',
                            data: {
                                support_flag: this.support_flag,
                                template_id: template.id
                            },
                            success: data => {
                                this.decoratePageList = Array.from(data, item => {
                                    return {
                                        name: item.name,
                                        value: item.id.toString()
                                    }
                                });
                            }
                        });
                    }
                });
            },
            //配置【微信】收款账户信息
            signInCalendarConfig(){
                //加载签到周期配置
                this.request({
                  url: '/signin_award_config/list',
                  success: data => {
                      this.signInCalendarData = data;
                      this.$refs.signInCalendarEdit.open();
                  }
                });
            },
            /**
             * 编辑配置
             * @returns {boolean}
             */
            browsePageConfig(type){
                //加载签到周期配置
                this.request({
                    url: '/signin_award_config/browse/pages',
                    data:{
                       "page_types":type==1?[0,5]:[8]
                    },
                    success: data => {
                        if (type == 1){
                            this.browsePageData = data.map(item => {
                                if (item.page_type == 0){
                                    item.page_type = -1;
                                }
                                return item;
                            });
                            this.$refs.browsePageDialogEdit.open();
                        }else {

                            this.browseProductList = data.map(item => {
                                if (item.page_type == 0){
                                    item.page_type = -1;
                                }
                                return item;
                            });
                            this.$refs.browseProductDialogEdit.open();
                        }
                    }
                });
            },
            /**
             * 签到日历，添加行
             * @returns {boolean}
             */
            addBrowsePageRow(){
                  if (this.browsePageData.length >= 30){
                      this.$message({
                          text: '最多添加30行记录',
                          icon: 'fail'
                      });
                      return false;
                  }
                  this.browsePageData.push({
                      "page_type":0,
                      "page_id":0,
                      "browse_duration":10,
                      "award_points":1
                  });
            },
            /**
             * 浏览页面任务，添加行
             * @returns {boolean}
             */
            addSignInCalendarRow(){
                  if (this.signInCalendarData.length >= 30){
                      this.$message({
                          text: '最多添加30行记录',
                          icon: 'fail'
                      });
                      return false;
                  }
                  this.signInCalendarData.push({
                      "award_points":1
                  });
            },
            /**
             * 提交签到周期配置
             */
            submitSignInAwardConfig(stop){
                stop();
                if (!this.signInCalendarData || this.signInCalendarData.length == 0){
                  this.$message({
                      text: '请至少添加一条记录',
                      icon: 'fail'
                  });
                }
                for (let i in this.signInCalendarData) {
                  let obj = this.signInCalendarData[i];
                  if (!obj.award_points ||isNaN(obj.award_points)) {
                      this.$message({
                        text: '请输入奖励积分数量',
                        icon: 'fail'
                      });
                      return false;
                  }
                }
                this.request({
                  url: '/signin_award_config/edit',
                  data:{
                     "award_config_list":this.signInCalendarData
                  },
                  success: data => {
                      this.$refs.signInCalendarEdit.close();
                      //刷新页面
                      this.getDetail();
                  }
                });
            },
            /**
             * 浏览页面奖励任务-提交数据
             */
            submitBrowsePageConfig(stop){
                stop();
                if (!this.browsePageData || this.browsePageData.length == 0){
                  this.$message({
                      text: '请至少添加一条记录',
                      icon: 'fail'
                  });
                  return false;
                }
                //判断是否存在重复数据
                var pageTpeName = [];
                for (let i in this.browsePageData) {
                  let obj = this.browsePageData[i];
                  if (!obj.page_type ||isNaN(obj.page_type)) {
                      this.$message({
                        text: '请选择页面类型',
                        icon: 'fail'
                      });
                      return false;
                  }
                  if (!obj.page_id ||isNaN(obj.page_id)) {
                      this.$message({
                        text: '请选择浏览页面',
                        icon: 'fail'
                      });
                      return false;
                  }
                  if (!obj.browse_duration ||isNaN(obj.browse_duration)) {
                      this.$message({
                        text: '请输入浏览时长',
                        icon: 'fail'
                      });
                      return false;
                  }
                  if (!obj.award_points ||isNaN(obj.award_points)) {
                      this.$message({
                        text: '请输入奖励积分数量',
                        icon: 'fail'
                      });
                      return false;
                  }
                  var key = obj.page_type + '-' + obj.page_id;
                  if (!(pageTpeName.includes(key))) { // 1-名称1 / 2-名称2 等等。。。
                        // 数组中没有就往里添加
                      pageTpeName.push(key)
                  }else {
                      this.$message({
                          text: '存在被重复选择的装修页面，请处理',
                          icon: 'fail'
                      });
                      return false;
                  }
                }
                var page_list = this.browsePageData.map(item => {
                    if (item.page_type == -1){
                        item.page_type = 0;
                    }
                    return item;
                });
                this.request({
                  url: '/signin_award_config/browse/page/edit',
                  data:{
                     "page_types":[0,5],
                     "page_list":page_list
                  },
                  success: data => {
                      this.$refs.browsePageDialogEdit.close();
                      //刷新页面
                      this.getDetail();
                  }
                });
            },
            /**
             * 浏览商品奖励任务-提交数据
             */
            submitBrowseProductConfig(stop){
                stop();
                if (!this.browseProductList || this.browseProductList.length == 0){
                  this.$message({
                      text: '请至少添加一件商品',
                      icon: 'fail'
                  });
                  return false;
                }
                for (let i in this.browseProductList) {
                  let obj = this.browseProductList[i];
                  if (!obj.browse_duration ||isNaN(obj.browse_duration)) {
                        this.$message({
                            text: '请输入浏览时长',
                            icon: 'fail'
                        });
                        return false;
                  }
                  if (!obj.award_points ||isNaN(obj.award_points)) {
                      this.$message({
                        text: '请输入奖励积分数量',
                        icon: 'fail'
                      });
                      return false;
                  }
                }
                this.request({
                  url: '/signin_award_config/browse/page/edit',
                  data:{
                     "page_types":[8],
                     "page_list":this.browseProductList
                  },
                  success: data => {
                      this.$refs.browseProductDialogEdit.close();
                      //刷新页面
                      this.getDetail();
                  }
                });
            },
            /**
             * 提交整体配置数据
             */
            submit() {
              let data = this.$refs.form.get();
              let submitData = Object.assign({},data);
              let platform_config_list = [];
              for (let key in submitData) {
                if(key !='SIGN_IN_CONTINUITY_REWARD_COUPON_NAME'){
                    platform_config_list.push({
                      config_item_code: key,
                      config_item_value: submitData[key] ? submitData[key].toString() : ''
                    });
                }
              }
              this.request({
                url: '/platform_config/edit',
                data: {
                  platform_config_list: platform_config_list
                },
                loading: true,
                success: data => {
                  this.$store.dispatch('getSystemConfig');
                  this.$message({
                    text: '保存成功',
                    icon: 'success'
                  });
                  //刷新页面
                  this.getDetail();
                }
              });
            }
        }
	}
</script>